"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addMemberLabel = addMemberLabel;
exports.delLabelRel = delLabelRel;
exports.deleteMemberLabel = deleteMemberLabel;
exports.downloadImportTemplate = downloadImportTemplate;
exports.getMemberListByLabelId = getMemberListByLabelId;
exports.labelBindMember = labelBindMember;
exports.queryMemberComboPage = queryMemberComboPage;
exports.queryMemberLabel = queryMemberLabel;
exports.queryMemberLabelPage = queryMemberLabelPage;
exports.syncCdpGroupVip = syncCdpGroupVip;
exports.updateMemberLabel = updateMemberLabel;
exports.uploadFile = uploadFile;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var requestUrl = '/xyMemberLabel';

// 会员标签分页
function queryMemberLabelPage(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/page',
    method: 'get',
    params: query
  });
}

// 查询详情
function queryMemberLabel(fnId) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/' + fnId,
    method: 'get'
  });
}

// 添加会员标签
function addMemberLabel(data) {
  return (0, _requestPIM.default)({
    url: requestUrl,
    method: 'post',
    data: data
  });
}

// 更新会员标签
function updateMemberLabel(data) {
  return (0, _requestPIM.default)({
    url: requestUrl,
    method: 'put',
    data: data
  });
}

// 绑定会员标签
function labelBindMember(data) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/bindMember',
    method: 'post',
    data: data
  });
}

// 会员基本信息
function queryMemberComboPage(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/memberComboPage',
    method: 'get',
    params: query
  });
}

// 同步CDP会员信息
function syncCdpGroupVip(id) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/syncCdpGroupVip',
    method: 'post',
    params: {
      id: id
    }
  });
}

// 上传Excel文件
function uploadFile(data) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/uploadFile',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 删除会员标签
function deleteMemberLabel(id) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/' + id,
    method: 'delete'
  });
}

// 根据标签ID获取会员列表
function getMemberListByLabelId(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/getMemberListByLabelId',
    method: 'get',
    params: query
  });
}

// 导入模板
function downloadImportTemplate() {
  return (0, _requestPIM.default)({
    url: requestUrl + '/uploadExcelModel',
    method: 'get',
    responseType: 'blob' // 重要：设置响应类型为blob以处理文件下载
  });
}

// 清空标签关联
function delLabelRel(labelId) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/delLabelRel',
    method: 'post',
    params: {
      labelId: labelId
    }
  });
}